import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sisMapActions from "store/modules/rds_sisMap";
import $ from "jquery";
import { LoadingContext } from "../../loadingContext";

import "./welfare.scss";

import { IoIosArrowForward } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { BsPlus, BsDash } from "react-icons/bs";
import { AiOutlineUnorderedList } from "react-icons/ai";

import SisSelect from "store/sis/component/SisSelect";
import SisOverlay from "store/sis/SisOverlay";

class Welfare extends Component {
	static contextType = LoadingContext;
	state = {
		title: "복지",
		activeItem: "",
		lstEmd: [],
		lstYmd: [],
		lstGb: [],
		source:"",
	};

	openSearchWrap = (evt) => {		
		let lstGb = [];
		
		$("#welfareWrap .itemsWrap").hide();
		$("#welfareWrap .searchWrap").show();
		$("#welfareWrap .close").show();
		$(".source").show();
		$("#welfareWrap .searchWrap").css("top","60px");		

		const id = $(evt.target).closest(".item").attr("id");
		const title = $(evt.target).closest(".item").find("span").text();
		let source = "";

		
		
		
		if(id==="oldman"){
			this.getYmd("welfare_facilities_gj");		
			this.getGb(id);
			source = "고령사회정책과"
		}else if(id==="daycare"){
			this.getYmd("daycare_info");		
			this.getGb(id);
			source = "여성가족과"
		}else if(id==="shelter"){
			this.getYmd("sultry_rest");
			source = "재난안전포털"
		}else if(id=="cultWelf"){
			this.getYmd("cult_welf");
			source = "돌봄정책과"
			//this.getGb(id);
		}

		this.setState({
			activeItem: id,
			title,
			source,
		});
	};

	closeSearchWrap = () => {
		$("#welfareWrap .searchWrap").hide();
		$("#welfareWrap .itemsWrap").show();
		$("#apartModal .close").click();
		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$("#welfareWrap .close").hide();
		$(".source").hide();
		$("#welfareWrap .searchWrap").css("top","");

		this.selectwelfareSgg.refresh();
		this.selectwelfareEmd.refresh();
		//this.selectwelfareStdYmd.refresh();

		this.setState({
			activeItem: "",
			title: "복지",
		});
	};

	// 읍면동 불러오기
	getEmd = (value) => {
		let lstEmd = [];
		

		$.ajax({
			url: "/map/getEmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				lstEmd = res;

				this.setState({
					lstEmd: [{ emdCd: "0", emdNm: "=== 전체 ===" }, ...lstEmd],
				});
			},
		});
	};

	getYmd = (value) => {
		let lstYmd = [];

		$.ajax({
			url: "/map/getYmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				
				lstYmd = res;

				this.setState({
					lstYmd: [...lstYmd],
				});
			},
		});
	};
	
	getGb = (id) => {
		let lstGb = [];

		if(id==="oldman"){
			lstGb = [
				{facilitiesGb:'WELGNWE01',facilitiesNm:'주거복지'}, 
				{facilitiesGb:'WELGNWE02', facilitiesNm:'의료복지'},
				{facilitiesGb:'WELGNWE03', facilitiesNm:'여가복지'},
				{facilitiesGb:'WELGNWE04', facilitiesNm:'노인보호'},
				{facilitiesGb:'WELGNWE05', facilitiesNm:'노인일자리지원'},
				{facilitiesGb:'WELGNWE06', facilitiesNm:'재가복지'}
			];
		}else if(id==="daycare"){
			lstGb = [
				{facilitiesGb:'DCGBND01',facilitiesNm:'가정'}, 
				{facilitiesGb:'DCGBND02', facilitiesNm:'국공립'},
				{facilitiesGb:'DCGBND03', facilitiesNm:'민간'},
				{facilitiesGb:'DCGBND04', facilitiesNm:'법인·단체등'},
				{facilitiesGb:'DCGBND05', facilitiesNm:'부모협동'},
				{facilitiesGb:'DCGBND06', facilitiesNm:'사회복지법인'},
				{facilitiesGb:'DCGBND07', facilitiesNm:'직장'}
			];
		}
		this.setState({
			lstGb: [{ facilitiesGb: "0", facilitiesNm: "=== 전체 ===" }, ...lstGb],
		});		
	};

	// 오버레이 클릭 이벤트(모달)ㅈ
	_overlayClickEvent = (ele, id, activeItem, noProps = false, mapZoom = false) => {
		const { actions, layout, sis } = this.props;
		let overlayElement;
		let col;

		 if (activeItem === "pharmacy") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="welfareTitle">{ele.pharmacyN}</span>
					<span className={ele.gubun === "파출소" ? "tag police" : "tag police2"}>{ele.gubun}</span>
					<span className="welfareAddress">
						{ele.roadAddr}
						<br />
						{ele.addr}
					</span>
					<span>전화번호 : {ele.tel}</span>
				</>
			);
		} else if (activeItem === "oldman") {
			let parkGb = ele.welfareGb;
			//crsCode = "EPSG:5186";
			let name = "";
			let classNm = "";

			switch (parkGb) {
				case "WELGNWE01":
					name = "주거";
					classNm = "tag oldman";
					break;
				case "WELGNWE02":
					name = "의료";
					classNm = "tag oldman2";
					break;
				case "WELGNWE03":
					name = "여가";
					classNm = "tag oldman3";
					break;
				case "WELGNWE04":
					name = "보호";
					classNm = "tag oldman4";
					break;
				case "WELGNWE05":
					name = "지원";
					classNm = "tag oldman5";
					break;
				case "WELGNWE06":
					name = "재가";
					classNm = "tag oldman6";
					break;
				
			}
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="welfareTitle">{ele.welfareName}</span>
					<span className={classNm}>{name}</span>
					<span className="welfareAddress">
						{ele.welfareAddr ? ele.welfareAddr : "-"}
					</span>
					<table>
						<caption>노인복지시설</caption>
						<tbody>
							<tr>
								<th>전화번호</th>
								<td >{ele.welfareTel ? ele.welfareTel : "-"}</td>
							</tr>
							<tr>
								<th>팩스번호</th>
								<td>{ele.welfareFax ? ele.welfareFax : "-"}</td>								
							</tr>
							<tr>
								<th>운영주체</th>
								<td>{ele.operatorNm ? ele.operatorNm : "-"}</td>
							</tr>
							<tr>
								<th>입소자 정원</th>
								<td>{ele.oldCnt != null && !isNaN(Number(ele.oldCnt)) ? Number(ele.oldCnt).toLocaleString() : "-"}명</td>
							</tr>
						</tbody>
					</table>
				</>
			);
		} else if (activeItem === "daycare") {
			let daycareGb = ele.daycareGb;
			//crsCode = "EPSG:5186";
			let name = "";
			let classNm = "";

			switch (daycareGb) {
				case "DCGBND01":
					name = "가정";
					classNm = "tag daycare";
					break;
				case "DCGBND02":
					name = "국공립";
					classNm = "tag daycare2";
					break;
				case "DCGBND03":
					name = "민간";
					classNm = "tag daycare3";
					break;
				case "DCGBND04":
					name = "법인";
					classNm = "tag daycare4";
					break;
				case "DCGBND05":
					name = "부모";
					classNm = "tag daycare5";
					break;
				case "DCGBND06":
					name = "사회";
					classNm = "tag daycare6";
					break;
				case "DCGBND07":
					name = "직장";
					classNm = "tag daycare7";
					break;
				
			}
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="welfareTitle">{ele.daycareName}</span>
					<span className={classNm}>{name}</span>
					<span className="daycareAddr">
						{ele.daycareAddr ? ele.daycareAddr : "-"}
					</span>
					<span>전화번호 : {ele.daycareTel ? ele.daycareTel : "-"}</span>
					
				</>
			);
		} else if (activeItem === "shelter"){
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="safetyTitle">{ele.facilityName}</span>
					<span className="safetyAddress">{ele.roadAddress ? ele.roadAddress : ele.address}</span>

					<table>
						<caption>무더위심터</caption>
						<tbody>
							<tr>
								<th>이용가능인원</th>
								<td>{ele.evacPerson != null && !isNaN(Number(ele.evacPerson)) ? Number(ele.evacPerson).toLocaleString() : "-"}명</td>
							</tr>
						</tbody>
					</table>
				</>
			);
		}else if (activeItem === "cultWelf") {
			let cultGbn = ele.cultGbn;
			//crsCode = "EPSG:5186";
			let name = "";
			let classNm = "";

			switch (cultGbn) {
				case "청소년수련시설":
					name = "청소년";
					classNm = "tag cultwelf";
					break;
				case "노인복지관":
					name = "노인";
					classNm = "tag cultwelf2";
					break;
				case "장애인복지관":
					name = "장애인";
					classNm = "tag cultwelf3";
					break;
				case "종합사회복지관":
					name = "종합";
					classNm = "tag cultwelf4";
					break;
				
			}
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="cultureTitle">{ele.cultNam}</span>
					<span className={classNm}>{name}</span>
					<span className="cultureAddress">
						{ele.cultAddr}
						<br/>
						{ele.cultRoad}
					</span>
					<table>
						<caption>복지시설</caption>
						<tbody>
							<tr>
								<th>시설구분</th>
								<td>{ele.cultGbn ? ele.cultGbn : "-"}</td>
							</tr>
							<tr>
								<th>수용인원(명)</th>
								<td>{ele.cultPers != null && !isNaN(Number(ele.cultPers)) ? Number(ele.cultPers).toLocaleString() : "-"}명</td>
							</tr>
							<tr>
								<th>면적(m²)</th>
								<td>{ele.cultArea != null && !isNaN(Number(ele.cultArea)) ? Number(ele.cultArea).toLocaleString() : "-"}</td>
							</tr>
							<tr>
								<th>전화번호</th>
								<td>{ele.cultTel ? ele.cultTel : "-"}</td>
							</tr>
						</tbody>
					</table>					
				</>
			);
		} 

		let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
		sis.sisMap.map.removeOverlay(overlay);

		actions.addResultOverlay({
			element: overlayElement,
			data: ele,
			id,
			className: "removeOverlayWrap",
			isTop: true,
			noProps,
			mapZoom,
		});
	};

	// 오버레이 클릭 이벤트(겹치는거 확인)
	overlayClickEvent = (ele, evt, overlay) => {
		const { actions, layout, sis } = this.props;

		let col = "";
		const activeItem = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("class");
		const id = `welfare_${activeItem}_removeOverlay`;
		$(`#${id}`).remove();

		let existOverlay = sis.sisMap.map.getOverlayById(id);
		if (existOverlay) sis.sisMap.map.removeOverlay(existOverlay);

		if (activeItem === "shelter") col = "facilityName";
		//else if (activeItem === "pharmacy") col = "pharmacyN";
		else if (activeItem === "oldman") col = "welfareName";
		else if (activeItem === "daycare") col = "daycareName";
		else if (activeItem === "cultWelf") col = "cultNam";
		//else col = "toiletNm";

		const arrOverlays = [];
		const pos = overlay.getPosition();
		const interval = 1;
		let xInterval = 0;
		let yInterval = 0;
		const overlays = sis.sisMap.map.getOverlays().getArray();

		$.each(overlays, (idx, item) => {
			let targetPos = item.getPosition();

			if (targetPos) {
				targetPos = targetPos;

				xInterval = Math.abs(pos[0] - targetPos[0]);
				yInterval = Math.abs(pos[1] - targetPos[1]);

				if (xInterval <= interval && yInterval <= interval) {
					arrOverlays.push(item);
				}
			}
		});

		if (arrOverlays.length > 1) {
			
			// if (true) {
			// 오버레이 생성
			const overlayElement = document.createElement("div");
			document.body.appendChild(overlayElement);
			overlayElement.className = "overlaySelector";
			overlayElement.id = "overlaySelector";

			let overlay = sis.sisMap.map.getOverlayById("overlaySelector");

			if (overlay) sis.sisMap.map.removeOverlay(overlay);
			overlay = new SisOverlay(`#overlaySelector`, sis.sisMap.map, "bottom-center", [0, 0]);
			overlay.setPosition(pos);
			$(overlayElement).parent().css("z-index", 9999);

			arrOverlays.forEach((item) => {
				const props = item.getProperties();

				if (props[col]) {
					const element = document.createElement("div");
					element.innerText = props[col];
					$(overlayElement).append(element);

					$(element).on("click", () => {
					this._overlayClickEvent(props, id, activeItem, true);
					sis.sisMap.map.removeOverlay(overlay);
					});
				}

				// $(overlayElement).append(`<div>${props.buildNm}</div>`);
			});
			
		} else {
		this._overlayClickEvent(ele, id, activeItem);
		}

		return;
	};

	// 오버레이 생성
	createOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;

		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$(".tabWrap .tab.active .searchWrap").append("<div class='listWrap'><span class='cnt'>검색결과 <a>" + data.length.toLocaleString() + "</a>건</span></div>");

		data.forEach((ele, idx) => {
			let overlayElement;

			/*if (activeItem === "hospital") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.hospitalNm}</span>
					</>
				);
				$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.hospitalNm}</span>`);
			} else if (activeItem === "pharmacy") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.pharmacyN}</span>
					</>
				);
				$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.pharmacyN}</span>`);
			} else*/ if (activeItem === "oldman") {

				let parkGb = ele.welfareGb;
				//crsCode = "EPSG:5186";
				let name = "";
				let classNm = "";

				switch (parkGb) {
					case "WELGNWE01":
						name = "주거";
						classNm = "tag oldman";
						break;
					case "WELGNWE02":
						name = "의료";
						classNm = "tag oldman2";
						break;
					case "WELGNWE03":
						name = "여가";
						classNm = "tag oldman3";
						break;
					case "WELGNWE04":
						name = "보호";
						classNm = "tag oldman4";
						break;
					case "WELGNWE05":
						name = "지원";
						classNm = "tag oldman5";
						break;
					case "WELGNWE06":
						name = "재가";
						classNm = "tag oldman6";
						break;
				}
				overlayElement = (
					<>
						<span className={activeItem}>
							<span className={classNm}  style={{marginRight:"3px"}}>{name}</span>
							{ele.welfareName}
						</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.welfareName}</span>`);
				
			} else if (activeItem === "daycare") {
				let daycareGb = ele.daycareGb;
				let name = "";
				let classNm = "";

				switch (daycareGb) {
					case "DCGBND01":
						name = "가정";
						classNm = "tag daycare";
						break;
					case "DCGBND02":
						name = "국공립";
						classNm = "tag daycare2";
						break;
					case "DCGBND03":
						name = "민간";
						classNm = "tag daycare3";
						break;
					case "DCGBND04":
						name = "법인";
						classNm = "tag daycare4";
						break;
					case "DCGBND05":
						name = "부모";
						classNm = "tag daycare5";
						break;
					case "DCGBND06":
						name = "사회";
						classNm = "tag daycare6";
						break;
					case "DCGBND07":
						name = "직장";
						classNm = "tag daycare7";
						break;
					
				}
				overlayElement = (
					<>
						<span className={activeItem}>
							<span className={classNm}  style={{marginRight:"3px"}}>{name}</span>
							{ele.daycareName}
						</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.daycareName}</span>`);
				
			}else if (activeItem === "shelter") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.facilityName}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.facilityName}</span>`);
			}else if (activeItem === "cultWelf") {
				let cultGbn = ele.cultGbn;
				let name = "";
				let classNm = "";

				switch (cultGbn) {
					case "청소년수련시설":
						name = "청소년";
						classNm = "tag cultwelf";
						break;
					case "노인복지관":
						name = "노인";
						classNm = "tag cultwelf2";
						break;
					case "장애인복지관":
						name = "장애인";
						classNm = "tag cultwelf3";
						break;
					case "종합사회복지관":
						name = "종합";
						classNm = "tag cultwelf4";
						break;
					
				}
				overlayElement = (
					<>
						<span className={activeItem}>
							<span className={classNm}  style={{marginRight:"3px"}}>{name}</span>
							{ele.cultNam}
						</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.cultNam}</span>`);
			}  

			// $(`.lst_${id}_${ele.gid}`).on("click", () => {
			// 	$(`#${id}_${ele.gid}`)[0].click();

			// 	const feature = this.props.sis.sisLayer.createFeatureByWKT(ele.geom);
			// 	feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
			// 	this.props.sis.sisMap.view.fit(feature.getGeometry().getExtent());
			// 	this.props.sis.sisMap.view.setZoom(8);
			// });

			actions.addResultOverlay({
				element: overlayElement,
				data: ele,
				id: `${id}_${ele.gid}`,
				className: "welfareOverlayWrap",
				onClick: this.overlayClickEvent,
				minZoom: 6,
				maxZoom: 10,
			});
		});

		// 오버레이 클릭 이벤트
		data.forEach((ele, idx) => {
			let overlayElement;
			if (activeItem==="oldman") {
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.equipNm}</span>`);

				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.welfareName}
					</span>`
				);
			} else if (activeItem==="daycare"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.daycareName}
					</span>`
				);
			}else if (activeItem==="shelter"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.facilityName}
					</span>`
				);
			}else if (activeItem==="cultWelf"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.cultNam}
					</span>`
				);
			}

			
		});

		$(".tabWrap .tab.active .searchWrap .listWrap").on("click", "span", (event) => {
			const target = $(event.currentTarget);

			const eleAttr = target.attr("data-ele");
			const id = target.attr("data-id")+"_removeOverlay";
			const activeItem = target.attr("data-active-item");

			if (!eleAttr) {
				console.error("data-ele 값이 없습니다.");
				return;
			}

			try {
				// JSON.parse() 한 번만 실행
				const ele = JSON.parse(eleAttr);
				
				// `this._overlayClickEvent()`를 호출하도록 변경 (화살표 함수 덕분에 this 유지됨)
				if (typeof this._overlayClickEvent === "function") {
					const mapZoom = true;
					const noProps = false;
					this._overlayClickEvent(ele, id, activeItem,noProps,mapZoom);
				} else {
					console.error("_overlayClickEvent 함수가 존재하지 않습니다.");
				}
			} catch (error) {
				console.error("JSON 파싱 오류:", error);
			}
		});

		if(activeItem === "oldman" ||activeItem === "daycare" ){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","270px");
		}else if(activeItem === "shelter"||activeItem==="cultWelf" ){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","225px");
		}
	};
	// 트리 범례 생성
	createTreeLegend = (props) => {
		const { activeItem } = this.state;

		if (activeItem === "oldman") {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag oldman">
								주거
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								주거복지
							</span>

							<span style={{ display: "inline-block" }} className="tag oldman2">
								의료
							</span>
							<span style={{ display: "inline-block" }} className="text">
								의료복지
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag oldman3">
								여가
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "50px",
								}}
								className="text"
							>
								여가복지
							</span>

							<span style={{ display: "inline-block" }} className="tag oldman4">
								보호
							</span>
							<span style={{ display: "inline-block" }} className="text">
								노인보호
							</span>
							<br />

							<span style={{ display: "inline-block" }} className="tag oldman5">
								지원
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "15px",
								}}
								className="text"
							>
								노인일자이지원
							</span>

							<span style={{ display: "inline-block" }} className="tag oldman6">
								재가
							</span>
							<span style={{ display: "inline-block" }} className="text">
								재가복지
							</span>
							<br />
						</div>
					</div>
					
				</>
				
			);
			
		}else if (activeItem === "daycare") {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag daycare">
								가정
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "90px",
								}}
								className="text"
							>
								가정
							</span>

							<span style={{ display: "inline-block" }} className="tag daycare2">
								국공립
							</span>
							<span style={{ display: "inline-block" }} className="text">
								국공립
							</span>
							

							<span style={{ display: "inline-block" }} className="tag daycare3">
								민간
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "90px",
								}}
								className="text"
							>
								민간
							</span>

							<span style={{ display: "inline-block" }} className="tag daycare4">
								법인
							</span>
							<span style={{ display: "inline-block" }} className="text">
								법인·단체등
							</span>
							

							<span style={{ display: "inline-block" }} className="tag daycare5">
								부모
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "64px",
								}}
								className="text"
							>
								부모협동
							</span>

							<span style={{ display: "inline-block" }} className="tag daycare6">
								사회
							</span>
							<span style={{ display: "inline-block" }} className="text">
								사회복지법인
							</span>
							<span style={{ display: "inline-block" }} className="tag daycare7">
								직장
							</span>
							<span style={{ display: "inline-block" }} className="text">
								직장
							</span>
							
						</div>
					</div>
					
				</>
				
			);
			
		}else if (activeItem === "cultWelf") {
			return (
				<>
					<div className="legendWrap">
						<div
							className="legendToggle"
							onClick={(e) => {
								$(e.target).closest(".legendToggle").find(".legendVisible").toggle();
								$(e.target).closest(".legendWrap").find(".legendContents").slideToggle("fast");
							}}
						>
							<BsPlus className="legendVisible hide" size="18px" />
							<BsDash className="legendVisible" size="18px" />
						</div>

						<span className="legendTitle">
							<AiOutlineUnorderedList size="15px" />
							범례
						</span>

						<div className="legendContents">
							<span style={{ display: "inline-block" }} className="tag cultwelf">
								청소년
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "15px",
								}}
								className="text"
							>
								청소년수련시설
							</span>

							<span style={{ display: "inline-block" }} className="tag cultwelf2">
								노인
							</span>
							<span style={{ display: "inline-block",marginRight: "15px" }} className="text">
								노인복지관
							</span>
							

							<span style={{ display: "inline-block" }} className="tag cultwelf3">
								장애인
							</span>
							<span
								style={{
									display: "inline-block",
									marginRight: "28px",
								}}
								className="text"
							>
								장애인복지관
							</span>

							<span style={{ display: "inline-block" }} className="tag cultwelf4">
								종합
							</span>
							<span style={{ display: "inline-block" }} className="text">
								종합사회복지관
							</span>							
						</div>
					</div>
				</>
			);
		}  	
	};
	// 검색
	search = async (evt, id) => {
		const { setLoading } = this.context; // ✅ context에서 setLoading 가져오기
    	setLoading(true); 
		$(".layerOpen").css("display","block");
		const { activeItem } = this.state;
		const { actions, sis } = this.props;

		let stdYmd = document.querySelector("select#selectLivingStdYmd");
		// stdYmd 값을 select에서 직접 가져오기
		if (stdYmd) {
			stdYmd = stdYmd.value;
		} else {
			stdYmd = null;  // 요소가 없으면 기본값 null 설정
		}

		// 기준년도 값이 없으면 1초 대기 후 실행
		const waitForStdYmd = () => {
			return new Promise(resolve => {
			  if (!stdYmd || stdYmd.trim() === "") {
				//console.log("기준년도 값이 없습니다. 1초 대기 중...");
				// 1초 대기 후, resolve를 호출하여 대기 끝냄
				setTimeout(() => {
				  resolve(); // Promise를 해결하여 대기 종료
				}, 2000);
			  } else {
				//console.log("기준년도 값이 있습니다.");
				resolve(); // 바로 resolve하여 대기 없이 진행
			  }
			});
		  };
		
		  // 비동기적으로 처리할 함수
		  await waitForStdYmd(); // 기준년도 값이 없으면 1초 기다리기

		let title = "";
		let data = [];
		//let stdYmd = "";
		let guBun = "";
		if(activeItem==="oldman"|| activeItem==="daycare" ||activeItem==="shelter"||activeItem==="cultWelf"){
			stdYmd = $("select#selectwelfareStdYmd").val() || $("select#selectwelfareStdYmd option:first").val() || "0";
			guBun = $("select#selectwelfareGb").val() || $("select#selectwelfareGb option:first").val() || "0";
		}
		let params = {
			sggCode: $("select#selectwelfareSgg").val(),
			emdCode: $("select#selectwelfareEmd").val(),
			stdYmd: stdYmd,
			guBun: guBun,
		};
		let color = "#ff0000";
		let url = "";
		let legend = "";

		 /*else if (activeItem === "pharmacy") {
			title = "약국";
			color = "#ff9800";
			url = "/map/selectPharmarcyInfo";
		}*/ if (activeItem === "oldman") {
			title = "노인복지시설";
			color = "#ffc107";
			url = "/map/selectWelfareFacilities";
			legend = this.createTreeLegend();
		} else if (activeItem === "daycare") {
			title = "어린이집";
			color = "#ffc107";
			url = "/map/selectDaycareInfo";
			legend = this.createTreeLegend();
		}/* else {
			title = "공중 화장실";
			color = "#fdd835";
			url = "/map/selectPublicToilet";
		}*/
		else if (activeItem === "shelter") {
			if(stdYmd == null){
				params.stdYmd = '2023';
			}
			title = "무더위쉼터";
			color = "#4caf50";
			url = "/map/selectSwelterShelter";
		}else if (activeItem === "cultWelf") {
			title = "복지시설 현황";
			color = "#ec407a";
			url = "/map/selectCultWelf";
			legend = this.createTreeLegend();
		}

		$.ajax({
			url,
			type: "post",
			data: params,
			success: (res) => {
				data = res.items ? res.items : res;

				if (data.length === 0) {
					alert("검색결과가 없습니다.");
					setLoading(false);
					return;
				}

				if (res.wkt) {
					const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					const extent = feature.getGeometry().getExtent();

					sis.sisMap.view.fit(extent);
				}

				const lyr = sis.sisLayer.getLayerById(`welfare_${activeItem}`);

				if (lyr) {
					actions.deleteResult({
						id: `welfare_${activeItem}`,
						refresh: true,
					});
				}

				// 트리아이템 생성
				actions.addResultItem({
					data: legend,
					id: `welfare_${activeItem}`,
					title,
					closeEvent: actions.deleteResult,
					checkboxEvent: actions.resultCheckboxHandler,
				});

				// 레이어 생성
				actions.addResultLayer({
					data,
					id: `welfare_${activeItem}`,
					type: "point",
					color,
					callback: () => {
						requestAnimationFrame(() => {
							setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
						  });
					  }
				});

				// 오버레이 생성
				this.createOverlay(data, `welfare_${activeItem}`);
			},
		});
	};

	render() {
		const { activeItem } = this.state;
		const { lstSgg, defaultSggCd } = this.props.sis;
		let searchElement;
				
		if ("oldman".indexOf(activeItem) > -1) {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectwelfareStdYmd"
							ref={(ref) => (this.selectwelfareStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}
							items={this.state.lstYmd}
						/>
					</div>
					
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectwelfareSgg"
							ref={(ref) => (this.selectwelfareSgg = ref)}
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectwelfareEmd"
							ref={(ref) => (this.selectwelfareEmd = ref)}
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">시설유형</span>
						<SisSelect
							id="selectwelfareGb"
							ref={(ref) => (this.selectwelfareGb = ref)}
							className="select"
							mapping={{
								key: "facilitiesGb",
								text: "facilitiesNm",
							}}
							items={this.state.lstGb}
						/>
					</div>
					
					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}else if ("daycare".indexOf(activeItem) > -1) {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectwelfareStdYmd"
							ref={(ref) => (this.selectwelfareStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}
							items={this.state.lstYmd}
						/>
					</div>
					
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectwelfareSgg"
							ref={(ref) => (this.selectwelfareSgg = ref)}
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectwelfareEmd"
							ref={(ref) => (this.selectwelfareEmd = ref)}
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">시설분류</span>
						<SisSelect
							id="selectwelfareGb"
							ref={(ref) => (this.selectwelfareGb = ref)}
							className="select"
							mapping={{
								key: "facilitiesGb",
								text: "facilitiesNm",
							}}
							items={this.state.lstGb}
						/>
					</div>
					
					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}else if ("shelter,cultWelf".indexOf(activeItem) > -1) {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectwelfareStdYmd"
							ref={(ref) => (this.selectwelfareStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}
							items={this.state.lstYmd}
						/>
					</div>
					
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectwelfareSgg"
							ref={(ref) => (this.selectwelfareSgg = ref)}
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectwelfareEmd"
							ref={(ref) => (this.selectwelfareEmd = ref)}
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>					
					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}else{
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectwelfareSgg"
							ref={(ref) => (this.selectwelfareSgg = ref)}
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectwelfareEmd"
							ref={(ref) => (this.selectwelfareEmd = ref)}
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>
					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}

		return (
			<div id="welfareWrap" className="contentsWrap">
				<div className="title">
					<span>{this.state.title}</span>
					<div className="close" onClick={this.closeSearchWrap}>
						<MdClose />
					</div>
				</div>
				<div className="source" style={{display:"none"}}>
					<span className="origin_tit">출처</span>
					<span className="origin_stxt">{this.state.source}</span>
				</div>
				<div className="itemsWrap">
					

					{/*<div id="pharmacy" className="item" onClick={this.openSearchWrap}>
						<img className="logo" alt="약국" src="/sis/images/map/welfare/icPharmacy.png" />
						<span>약국</span>
						<IoIosArrowForward className="arrow" />
					</div>*/}

					<div id="oldman" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="노인복지시설" src="/sis/images/map/welfare/icOldman.png" />*/}
						<span>노인복지시설</span>
						<IoIosArrowForward className="arrow" />
					</div>

					{/*<div id="toilet" className="item" onClick={this.openSearchWrap}>
						<img className="logo" alt="공중 화장실" src="/sis/images/map/welfare/icToilet.png" />
						<span>공중 화장실</span>
						<IoIosArrowForward className="arrow" />
					</div>*/}

					<div id="daycare" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="어린이집" src="/sis/images/map/welfare/icToilet.png" />*/}
						<span>어린이집</span>
						<IoIosArrowForward className="arrow" />
					</div>

					<div id="shelter" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="무더위쉼터" src="/sis/images/map/welfare/icToilet.png" />*/}
						<span>무더위쉼터</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="cultWelf" className="item" onClick={this.openSearchWrap}>
						{/*<img className="logo" alt="복지시설 현황" src="/sis/images/map/culture/icInformation.png" />*/}
						<span>복지시설 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
				</div>

				<div className="searchWrap">{searchElement}</div>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		sis: state.sisMap,
	}),
	(dispatch) => ({
		actions: bindActionCreators(sisMapActions, dispatch),
	})
)(Welfare);
